import { requireAuth } from '@/features/auth/guards/require-auth'
import { MaterialIssuesListPage } from '@/features/material-issues/pages/material-issues-list-page'
import { materialIssuesGlobalListQuery } from '@/features/material-issues/queries/material-issue-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/material-issues/')({
  beforeLoad: async (params) => {
    const ctx = await requireAuth(params)
    if (!ctx.user.is_staff) {
      throw redirect({ to: '/projects/' })
    }
    return ctx
  },
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(materialIssuesGlobalListQuery()),
      queryClient.ensureQueryData(projectsListQuery()),
      queryClient.ensureQueryData(usersListQuery()),
      queryClient.ensureQueryData(warehousesListQuery()),
    ]),
  component: MaterialIssuesListPage,
  staticData: { crumb: messages.crumbs.materialIssues },
})
